var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "imagecard clickable border-0",
      attrs: { "no-body": "", "bg-variant": "transparent" },
      on: {
        click: function ($event) {
          return _vm.selectItem(_vm.item)
        },
      },
    },
    [
      _c(
        "b-card-body",
        { staticClass: "position-relative p-0" },
        [
          _c("b-card-img", {
            attrs: { src: _vm.item.previewImage, alt: _vm.item.title },
          }),
          _c("div", { staticClass: "overlay" }, [
            _c("div", {
              staticClass: "text",
              domProps: { innerHTML: _vm._s(_vm.selectDesign) },
            }),
          ]),
          _vm.item.coverLetterId !== 0 && _vm.item.coverLetterId !== undefined
            ? _c(
                "div",
                {
                  staticClass:
                    "cover-letter-icon position-absolute d-flex rounded px-3 py-2",
                },
                [
                  _c("b-icon", {
                    attrs: {
                      icon: "file-text",
                      variant: "white",
                      "font-scale": "1.3",
                    },
                  }),
                  _c("div", { staticClass: "icon-text text-white" }, [
                    _vm._v(
                      _vm._s(_vm.t.CV_Tool_Tooltip_Cover_Letter_Available)
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-card-footer",
        { attrs: { "footer-bg-variant": "transparent" } },
        [
          _c("b-card-text", {
            staticClass: "text-center m-0 pt-2 pb-3 text-truncate",
            domProps: { innerHTML: _vm._s(_vm.item.title) },
          }),
          _vm.item.template === true
            ? _c("Avatar", {
                staticClass: "position-absolute cv-list-avatar",
                attrs: { icon: "lightning-fill", text: "AUTO" },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }